import { Link } from "react-router-dom";
import { Phone, Mail, Facebook, Twitter, Youtube, Instagram } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_financial-solutions-1/artifacts/hqf4b4fe_2%20-%20Copy.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#111111] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img src={LOGO_URL} alt="KK Mortgage Solutions" className="h-20 w-auto" />
            </div>
            <div className="space-y-3 text-gray-400 text-sm">
              <a
                href="mailto:kunal.kapadia@themoney-group.co.uk"
                data-testid="footer-email"
                className="flex items-center gap-2 hover:text-[#e06665] transition-colors"
              >
                <Mail className="w-4 h-4 text-[#d64241]" />
                kunal.kapadia@themoney-group.co.uk
              </a>
              <a
                href="tel:07538962618"
                data-testid="footer-phone"
                className="flex items-center gap-2 hover:text-[#e06665] transition-colors"
              >
                <Phone className="w-4 h-4 text-[#d64241]" />
                07538962618
              </a>
            </div>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-5">Explore</h4>
            <ul className="space-y-3 text-sm">
              {[
                { name: "Home", path: "/" },
                { name: "About", path: "/about" },
                { name: "Services", path: "/services" },
                { name: "Calculator", path: "/calculator" },
                { name: "FAQs", path: "/faqs" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                    className="text-gray-400 hover:text-[#e06665] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-5">Services</h4>
            <ul className="space-y-3 text-sm">
              {[
                { name: "Mortgage", path: "/services/mortgage" },
                { name: "Protection", path: "/services/protection" },
                { name: "Home Insurance", path: "/services/home-insurance" },
              ].map((service) => (
                <li key={service.name}>
                  <Link
                    to={service.path}
                    data-testid={`footer-service-${service.name.toLowerCase().replace(' ', '-')}`}
                    className="text-gray-400 hover:text-[#e06665] transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Special Schemes */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-5">Special Schemes</h4>
            <ul className="space-y-3 text-sm">
              {[
                { name: "Help To Buy", path: "/schemes/help-to-buy" },
                { name: "Right To Buy", path: "/schemes/right-to-buy" },
                { name: "Right To Acquire", path: "/schemes/right-to-acquire" },
                { name: "Shared Ownership", path: "/schemes/shared-ownership" },
              ].map((scheme) => (
                  <li key={scheme.name}>
                    <Link
                      to={scheme.path}
                      data-testid={`footer-scheme-${scheme.name.toLowerCase().replace(/ /g, '-')}`}
                      className="text-gray-400 hover:text-[#e06665] transition-colors"
                    >
                      {scheme.name}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>

        <Separator className="my-10 bg-[#222222]" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} All rights reserved, KK Mortgage Solutions
          </p>
          <div className="flex items-center gap-4">
            {[
              { icon: Facebook, label: "Facebook" },
              { icon: Twitter, label: "Twitter" },
              { icon: Youtube, label: "Youtube" },
              { icon: Instagram, label: "Instagram" },
            ].map(({ icon: Icon, label }) => (
              <a
                key={label}
                href="#"
                data-testid={`footer-social-${label.toLowerCase()}`}
                aria-label={label}
                className="w-10 h-10 rounded-full bg-[#1a1a1a] flex items-center justify-center text-gray-400 hover:bg-[#d64241] hover:text-white transition-all duration-200"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
